import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import get from 'lodash.get';
import { makeUniqueID } from 'acq-utils/lib/misc';
import { postLeadGenForCorpPages } from 'service_modules/services/open-shop-platform/lead-gen';
import {
  sendDTMClickEvent,
  setPageAttributes
} from 'service_modules/models/dtm-tagging';
import { fireMarketingPixels } from 'src/universal/utils/thirdPartyScriptHelpers/fireMarketingPixels';
import { FormView } from 'src/universal/components/LeadForm/formView';
import { ResultView } from 'src/universal/components/LeadForm/resultView';
import { FormBackNav } from './formBackNav';
import { StickyContainer } from './stickyContainer';
import formStyles from './__styles__/formView.scss?modules';
import resultStyles from './__styles__/resultView.scss?modules';
import trackExperimentMetricFactory from 'src/universal/components/Experiments/utils/trackExperimentMetricFactory';
import newFormCore from './__styles__/newFormCore.scss?modules';

export const LeadForm = React.memo(({ content, layoutStyles, dismissModalForm }) => {
  useEffect(() => {
    const inputs = document.querySelectorAll(
      'select#annual-revenue, input#fullName, input#businessName, input#businessEmail, input#businessPhoneNumber'
    );
    for (const field of inputs) {
      field.setAttribute('required', '');
    }
  }, []);
  const [formResult, setFormResult] = useState(null);
  const marketingPixels = get(content, 'form.marketingPixels') || [];

  const handleSubmit = formVals => {
    const dtm = get(content, 'form.submit.dtm') || {};
    trackExperimentMetricFactory({
      element: 'corp:leadFormSubmit',
      useDebounce: true
    })();
    const optionalAnalyticsQueryParams =
      get(content, 'form.analyticsQueryParams') || [];

    const formId = makeUniqueID(20);
    // this must happen before sendDTMClickEvent below
    setPageAttributes({
      purchaseID: formId
    });
    sendDTMClickEvent(dtm);
    fireMarketingPixels(marketingPixels);

    postLeadGenForCorpPages(formVals, optionalAnalyticsQueryParams, formId)
      .then(resp => {
        setFormResult(resp && resp.status === 200 ? 'success' : 'failure');
      })
      .catch(() => {
        setFormResult('failure');
      });
  };

  const isResultOrError = formResult !== null;

  const qeId = 'corp-vac-lead-form';

  return (
    <div
      className={clsx(layoutStyles.rightRail, {
        [formStyles.isResultOrErr]: isResultOrError
      })}
      data-qe-id={qeId}
    >
      <FormBackNav
        content={content.links}
        onFormDismiss={dismissModalForm}
        qeId={`${qeId}-back-nav`}
        formStyles={formStyles}
      />
      <StickyContainer formStyles={formStyles}>
        {isResultOrError ? (
          <ResultView
            content={content}
            formResult={formResult}
            onResultClose={dismissModalForm}
            qeId={`${qeId}-result-view`}
            resultStyles={resultStyles}
          />
        ) : (
          <FormView
            content={content}
            onFormSubmit={handleSubmit}
            qeId={qeId}
            formStyles={formStyles}
            coreFormStyles={newFormCore}
            instanceId="corpVac"
          />
        )}
      </StickyContainer>
    </div>
  );
});
